module.exports = __webpack_public_path__ + "static/team-9-7039a75a5675aabbfff22b8c415c89ad.png";